import { ModalOnCencel, ModalOnConfrim } from '@hooks/useModal'
import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'

const MessageBox = styled.div`
  ${tw`flex flex-col py-3 text-base`}
  word-break: keep-all;
`

interface Props {
  children?: React.ReactNode
  onConfirm?: ModalOnConfrim
  onCencel?: ModalOnCencel
  mode?: 'req' | 'res'
  errorData?: any
}

const MessageModal = ({
  children,
  onConfirm,
  onCencel,
  mode = 'res',
  errorData,
}: Props) => {
  const handleConfirm = () => {
    onConfirm?.(true)
  }
  const handleCencel = () => {
    onConfirm?.(false)
  }

  const errorMessageObjToRenderArray = (errorMessageObj: {
    [key: string]: string
  }) => {
    const ret: any = []
    const messages = Object.entries(errorMessageObj).map(([_, value]) => value)
    messages.forEach((msg, idx) => {
      ret.push(msg)
      if (idx !== messages.length - 1) {
        ret.push(<br />)
      }
    })
    return ret
  }

  const getMessageFromRemoteOrChildren = () => {
    if (errorData?.message) {
      if (typeof errorData.message === 'object') {
        return errorMessageObjToRenderArray(errorData.message)
      }
      return errorData.message
    }
    return children
  }

  return (
    <div className="justify-center pb-15 py-25 px-25 max-w-300 modal">
      <MessageBox tw="py-10" className="flex flex-col text-base">
        {getMessageFromRemoteOrChildren()}
      </MessageBox>
      <div className="flex justify-end w-full gap-8 mt-15">
        <button className="py-5 font-bold px-15 button" onClick={handleConfirm}>
          확인
        </button>
        {mode === 'req' && (
          <button
            className="py-5 font-bold px-15 button"
            onClick={handleCencel}
          >
            취소
          </button>
        )}
      </div>
    </div>
  )
}

export default MessageModal
